export const NAV = [
  {
    label: "About", to: "/about",
    items: [
      ["Who We Are", "/about"], ["Our Story", "/about#story"], ["Mission & Vision", "/about#mission"], ["Leadership", "/governance-and-transparency#trustees"],
      ["Trust & Transparency", "/governance-and-transparency"], ["How We Work", "/operating-model"], ["Political Neutrality", "/political-neutrality"], ["Safeguarding", "/safeguarding"], ["Contact", "/contact"],
    ],
  },
  {
    label: "What We Do", to: "/programmes",
    items: [
      ["Emergency & Basic Needs", "/emergency"], ["Education & Skills", "/programmes/education"], ["Empowerment & Livelihoods", "/empowerment"],
      ["Shelter & Housing", "/housing"], ["Health & Wellbeing", "/programmes/health"], ["Community Infrastructure", "/programmes/light-up-rural-nigeria"],
      ["Family Food Support", "/family-support"], ["Water & Sanitation", "/programmes/water-sanitation"], ["Agriculture & Food Security", "/programmes/agriculture"], ["All Programmes", "/programmes"],
    ],
  },
  {
    label: "Get Help", to: "/get-help",
    items: [
      ["Apply for Support", "/apply"], ["Emergency Help", "/emergency/help"], ["Continue a Saved Application", "/apply?resume=1"], ["Report a Community Need", "/report-a-need"], ["Track Application", "/apply/track"],
    ],
  },
  {
    label: "Projects & Impact", to: "/projects",
    items: [
      ["Projects", "/projects"], ["Impact Dashboard", "/transparency"], ["Impact Stories", "/impact#stories"], ["Beneficiary Testimonials", "/testimonials"], ["Reports", "/governance-and-transparency#annual_reports"],
      ["Project Verification", "/verify"], ["Impact Map", "/impact-map"], ["Research & Data", "/operating-model"], ["Updates & News", "/updates"],
    ],
  },
  {
    label: "Learn", to: "/learn",
    items: [
      ["Learning Hub", "/learn"], ["Financial Literacy Basics", "/learn/financial-literacy-basics"], ["From Grant to Sustainable Business", "/learn/from-grant-to-sustainable-business"], ["Training & Certification Centre", "/portal/training"], ["Book Store", "/store"], ["Free Courses", "/learn?filter=free"], ["Financial Education", "/learn?category=financial_education"], ["Business", "/learn?category=entrepreneurship"],
      ["Digital Skills", "/learn?category=digital_technology"], ["Vocational Skills", "/learn?category=vocational_construction"], ["Opportunities", "/learn#opportunities"],
      ["Spiritual Encouragement", "/learn?category=spiritual"], ["Training Partners", "/training-partners"],
    ],
  },
  {
    label: "Get Involved", to: "/volunteer",
    items: [
      ["Volunteer", "/volunteer"], ["Volunteer Training Centre", "/portal/training"], ["Employment Bridge", "/employment"], ["Partner", "/partner/apply"], ["Corporate / CSR", "/international#corporate"], ["Sponsor a Project", "/sponsor-a-project"],
      ["Monthly Giving", "/donate?type=monthly"], ["International Partnerships", "/international"], ["Verify a Volunteer", "/volunteer/verify"], ["Verify a Certificate", "/verify-certificate"],
    ],
  },
];

export const PORTALS = [
  ["Beneficiary Portal", "/beneficiary-portal", "Track applications and support"],
  ["Volunteer Portal", "/volunteer/portal", "Your DKF-VOL membership"],
  ["Training Centre", "/portal/training", "Courses, assessments and certificates"],
  ["Donor Portal", "/donor-portal", "Receipts and impact updates"],
  ["Partner Portal", "/partner/track", "Track a partnership proposal"],
  ["Job Partner Portal", "/employment/partner", "Offer jobs to verified volunteers"],
  ["Job Seeker Portal", "/employment/jobseeker", "Volunteers looking for work"],
  ["Community Chat", "/community", "Members-only chat for volunteers, donors and partners"],
  ["Staff Login", "/admin/login", "Authorised staff only"],
];

export const FOOTER_COLUMNS = [
  { title: "Foundation", links: [["Who We Are", "/about"], ["What We Do", "/programmes"], ["How We Work", "/operating-model"], ["Updates & News", "/updates"], ["Book Store", "/store"], ["Contact", "/contact"]] },
  { title: "Get Help", links: [["Apply for Support", "/apply"], ["Emergency Help", "/emergency/help"], ["Continue a Saved Application", "/apply?resume=1"], ["Report a Community Need", "/report-a-need"], ["Track Application", "/apply/track"], ["Beneficiary Portal", "/beneficiary-portal"]] },
  { title: "Get Involved", links: [["Donate", "/donate"], ["Monthly Giving", "/donate?type=monthly"], ["Sponsor a Project", "/sponsor-a-project"], ["Volunteer", "/volunteer"], ["Training Centre", "/portal/training"], ["Employment Bridge", "/employment"], ["Community Chat", "/community"], ["Partner", "/partner/apply"]] },
  { title: "Transparency", links: [["Projects & Impact", "/projects"], ["Beneficiary Testimonials", "/testimonials"], ["Impact Dashboard", "/transparency"], ["Trust & Transparency", "/governance-and-transparency"], ["Project Verification", "/verify"], ["Verify a Certificate", "/verify-certificate"], ["Request a Document", "/governance/request-access"]] },
  { title: "Legal & Safety", links: [["Privacy", "/governance-and-transparency#policies"], ["Safeguarding", "/safeguarding"], ["Complaints", "/complaints"], ["Whistleblowing", "/complaints#whistleblowing"], ["Report Fraud", "/complaints#fraud"]] },
];
